import { difference, union, uniq } from 'lodash'

const filterNotNums = (value?: string) => {
  if (!value) {
    return ''
  }

  return value.replace(/\D/g, '')
}

const addManyItensArray = (values: string[], array: string[]): string[] => union(values, array)

const removeManyItensArray = (values: string[], array: string[]) => {
  const indexSet = uniq(values)
  return difference(array, indexSet)
}

const removeEmptySpaces = (str: string) => str.replace(/  +/g, ' ').trim()

const getFirstLetter = (str: string) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase()
}

export { filterNotNums, addManyItensArray, removeManyItensArray, removeEmptySpaces, getFirstLetter }
